'use client';

import React, { useCallback, useState, useEffect } from 'react';
import { Solicitud } from '@/types/solicitud';
import SolicitudManagement from './SolicitudManagement';
import { solicitudService } from '@/lib/api/solicitudService';
import { getCurrentUser } from '@/services/authService';
import ErrorMessage from '@/components/common/ErrorMessage';

/**
 * Módulo Fondeados:
 * - estatus = "FONDEADO"
 * - fechaFondeado >= primer día del mes actual (solo del mes en curso)
 * - Filtra por scope si el usuario tiene scope="self"
 * - Ordena por fechaEntregaARiesgos
 * - Módulo de consulta/visualización de créditos fondeados del mes
 */
const FondeadosManagement: React.FC = () => {
  const [initialSolicitudes, setInitialSolicitudes] = useState<Solicitud[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFondeados = useCallback(async () => {
    setLoading(true);
    setError(null);
    const currentUser = getCurrentUser();
    if (!currentUser || !currentUser.ownerID) {
      setError("No se pudo obtener el ID del usuario actual.");
      setLoading(false);
      return;
    }
    try {
      const response = await solicitudService.getFondeados(currentUser.ownerID);
      if (response.data) {
        setInitialSolicitudes(response.data);
      } else {
        setError(response.error || "Error al cargar solicitudes fondeadas.");
      }
    } catch (err: any) {
      setError(err.message || "Error de red al cargar solicitudes.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFondeados();
  }, [fetchFondeados]);

  if (loading) {
    return <div className="text-center py-4">Cargando solicitudes...</div>;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  return (
    <SolicitudManagement
      fixedStatus="FONDEADO"
      title="Fondeados (Mes en curso)"
      modulo="fondeados"
      initialSolicitudes={initialSolicitudes}
      customFetch={fetchFondeados}
      showNewButton={false}
      montoColumn="autorizado"
    />
  );
};

export default FondeadosManagement;
